import React from 'react';
const SelectedPatient = ({ id, initials, name, removeSelectedPatient }) => {
    return (
      <div className="selected-contact pr-2">
        <span data-letters={initials}></span>
        <i
          className="fa fa-close selected-close-icon"
          onClick={() => removeSelectedPatient(id)}
          style={{ cursor: "pointer" }}
        ></i>
        <div className="selected-names">{name.split(" ")[0]}</div>
      </div>
    );
  };

  export default SelectedPatient